import React from 'react';

const clients = [
   { id: 1, src: "/clients/1.svg", alt: "Client 1 logo" },
   { id: 2, src: "/clients/2.svg", alt: "Client 2 logo" },
   { id: 3, src: "/clients/3.svg", alt: "Client 3 logo" },
   { id: 4, src: "/clients/4.svg", alt: "Client 4 logo" },
   { id: 5, src: "/clients/5.svg", alt: "Client 5 logo" },
   { id: 6, src: "/clients/6.svg", alt: "Client 6 logo" },
];

const ClientLogos = () => {
   return (
      <section className="py-4 bg-dark-1">
         <div className="container mx-auto px-4">
            <div className="flex flex-wrap justify-center md:justify-between items-center gap-4 md:gap-0">

               {clients.map((client) => (
                  <div
                     key={client.id}
                     className="w-1/3 sm:w-1/4 md:w-1/6 px-2 sm:px-4 flex-shrink-0"
                  >
                     <div className="flex justify-center items-center">
                        <img
                           src={client.src}
                           alt={client.alt}
                           className="w-full max-w-[120px] object-contain dark:invert dark:opacity-80"
                        />
                     </div>
                  </div>
               ))}

            </div>
         </div>
      </section>
   );
};

export default ClientLogos;